import { createContext } from "react";
import { VenueBrandForContext } from "./venueBrand";

export const VenueContext = createContext<VenueBrandForContext | {}>({});
